import React, { Component } from 'react';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { renderColorPicker, renderInput } from 'src/components/misc/redux-form-helpers';
import autoBind from 'react-autobind';
import { isBlank } from 'src/utils/helpers';
import { connect } from 'react-redux';

class CalendarSeasonForm extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            isDisabled: true,
            calculationValue: undefined,
        };
    }

    render() {
        const { handleSubmit, t } = this.props;

        return (
            <form className="form-horizontal" onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-6">
                        <Field
                            name="name"
                            label={`${t('common_phrases.name')} *`}
                            hintText={t('calendar_season_calculation.form.name_hint')}
                            component={renderInput}
                        />
                    </div>
                    <div className="col-md-6">
                        <Field
                            name="calendarColor"
                            label={`${t('calendar_season_calculation.form.color_calendar')} *`}
                            component={renderColorPicker}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

const validate = (values, props) => {
    const { t } = props;
    const errors = {};
    if (isBlank(values.name)) errors.name = t('error_missing.fill_in_name');
    if (!values.calendarColor) errors.calendarColor = t('error_missing.fill_in_calendar_color');
    return errors;
};
const selector = formValueSelector('calendarSeasonForm');

const mapStateToProps = state => {
    return {
        isDefault: selector(state, 'isDefault'),
    };
};
export default reduxForm({
    form: 'calendarSeasonForm',
    validate,
    asyncBlurFields: ['name'],
})(connect(mapStateToProps)(CalendarSeasonForm));
